module.exports = {"341602001":"花戏楼","341602002":"薛阁","341602003":"汤陵","341602100":"古井镇","341602101":"芦庙镇","341602102":"华佗镇","341602103":"魏岗镇","341602104":"牛集镇","341602105":"颜集镇","341602106":"五马镇","341602107":"十八里镇","341602108":"谯东镇","341602109":"十九里镇","341602110":"沙土镇","341602111":"观堂镇","341602112":"大杨镇","341602113":"城父镇","341602114":"十河镇","341602115":"双沟镇","341602116":"淝河镇","341602117":"古城镇","341602118":"龙杨镇","341602119":"立德镇","341602200":"张店乡","341602201":"赵桥乡","341602400":"亳州市经济技术开发区","341602401":"安徽亳州工业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/341602.json
// module id = 1145
// module chunks = 0